class URLResolver {
  constructor(routes) {
    this.urlPatterns = routes;
  }

  getPath(patternName) {
    const path = this.urlPatterns[patternName];

    if (typeof path === 'undefined') {
      throw new Error(`Unknown Route Requested: "${patternName}"`);
    }

    return path;
  }

  reverse(patternName, params) {
    const path = this.getPath(patternName);

    return params
      ? Object.keys(params).reduce(
          (prev, key) => prev.replace(`:${key}`, params[key]),
          path
        )
      : path;
  }

  query(patternName, params, queryParams = {}) {
    const urlPath = this.reverse(patternName, params);
    const queryString = new URLSearchParams(queryParams).toString();
    const url = urlPath + '?' + queryString;

    return url;
  }
}

export default URLResolver;
